import Tick from '@/modules/tick/tick';
import User from '@/classes/user';
import tick from '@/modules/tick/tick';
import Vue from 'vue';

// import Auth from '@/auth/auth';
import ImsError from '@/modules/errors/errors';

// Declare Window
declare let window: any; // used for window._bearer references (indycar app)

// Setup User Object with new auth
let $User = new User();

// Allow Vue to access them
Vue.prototype.$User = $User;
// Vue.prototype.$auth = $auth;

export default {
  state: {
    loggedIn: false,
    loggingIn: false,
    user: $User,
    passedBearer: null // for indycar app
  },
  mutations: {
    loggedIn(state: any, isLoggedIn: boolean = false) {
      state.loggedIn = isLoggedIn;
    },
    set(state: any, user: User) {
      state.user = user;
      state.loggedIn = user.loggedIn;
    },
    loggingIn(state: any, isLoggingIn: boolean) {
      state.loggingIn = isLoggingIn;
    },
    passedBearer(state: any, bearer: string) {
      state.passedBearer = bearer;
    }
  },
  actions: {
    /**
     * Init User
     * Fire off the user initialization
     * Setup listener for any changes
     * @param context Store Context
     * @param user Iniitalized User
     */
    async 'user/init'(context: any) {
      /**
       * Initialize the User
       */

      /**
       * Indy Car Auth Check
       * Check for Indycar _bearer variable
       * if set, set it in the state scope.
       */
      if (window._bearer) {
        context.commit('passedBearer', window._bearer);
      }

      /**
       * User onChange Event
       * Listen for user changes
       */
      $User.onChange(async (type: any) => {
        if (type == 'logged-in') {
          context.commit('loggedIn', true);
        } else if (type == 'logged-out') {
          context.commit('loggedIn', false);
        }
        context.commit('set', $User);
      });

      // Initialize the User Object
      $User.init();
      // Return User
      return $User;
    },
    /**
     * Check for Profile
     * This is an important call because it
     * looks for the users profile and checks for proper authentication.
     * Since the profile is required, right after logining in
     * we will call getProfile. If we get an empty profile but no errors
     * we will show the profile modal. If we get an error
     * we will display that to the user.
     */
    async 'user/checkForProfile'(context: any) {
      // Show the Loader
      let loaderComplete = await context.dispatch(
        'loader/start',
        'Getting Player Profile..'
      );

      // Try to get profile
      try {
        // get profile from service
        let profile: any = await $User.service.getProfile();
        // If profile assign to user
        if (profile) {
          $User.profile = profile;
        } else {
          // If no error and no profile - load the profile screen
          context.dispatch('interact/modals/profile/toggle');
        }
        // CLose Loader
        loaderComplete();
      } catch (e) {
        // An Error happened - we're not going to close the loader
        // Let it time out.. This error isn't good.
        let profileError = new ImsError(e);
        // If there's a window _bearer INDYCAR
        if (window._bearer) {
          context.dispatch(
            'interact/error',
            'It looks like your session is no longer valid. Please close this window and try again.'
          );
        } else {
          // Display error message
          context.dispatch('interact/error', profileError.getDescription());
        }
      }

      // context.dispatch('interact/loading/hide');
      // return profile;
    },
    /**
     * Set User
     * Update the user in the state and to kick off reactions
     * @param context Store Context
     * @param user Iniitalized User
     */
    async 'user/set'(context: any, user: User) {
      context.commit('set', user);
      context.commit('loggedIn', user.isLoggedIn());
    },
    /**
     * Log a User In
     * @param context Store context
     */
    async 'user/login'(context: any) {
      // Tell state we're logging in
      context.commit('loggingIn', true);
      try {
        // Try the Login
        await $User.login();
      } catch (e) {
        // Catch and display any errors
        context.dispatch('interact/popmenu', {
          title: 'Error',
          description: e.message,
          cancelButton: 'Ok'
        });
      }
      // Tell state we're done loggin in
      context.commit('loggingIn', false);
    },
    // Basically a logout with out asking
    // Good for clearing sessions if B2C gets
    // mangled
    async 'user/clear/everything'(context: any) {
      try {
        await $User.logout();
      } catch (e) {
        alert(e.message);
      }
    },
    /**
     * Log the user out - but confirm first
     */
    async 'user/logout'(context: any) {
      let conf = confirm('Are you sure you want to logout?');
      if (conf) {
        await $User.logout();
      }
    }
  },
  getters: {
    /**
     * Return the $User
     * Used in other stores that might not have access to $User
     */
    user(state: any) {
      return $User;
    },
    /**
     * Is User using Internet Explorer
     * This app does not support IE
     * we will display a message saying as such
     */
    'user/isIE'(state: any) {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
        return true;
      }
      return false;
    }
  }
};
